import propTypes from 'prop-types';
import { ChevronLeft, ChevronRight } from 'react-feather';
import KiperButton from '../KiperButton';
import Select from '../Select';
import {
  Container,
  FormGroup,
  Label,
  PageSizeContainer,
} from '../Pagination/styles';

const pageSizeOptions = [10, 25, 50, 100].map(value => ({
  value,
  label: String(value),
}));

const SimplePagination = ({
  pageSize,
  hasNext,
  hasPrevious,
  onPageChange,
  onPageSizeChange,
  loading,
  translate: t,
}) => {
  const handleNextPage = () => {
    onPageChange(1);
  };

  const handlePreviousPage = () => {
    onPageChange(-1);
  };

  return (
    <Container>
      <FormGroup>
        <Label htmlFor="pageSize">
          {t('common:pagination.lines-per-page')}
        </Label>
        <PageSizeContainer>
          <Select
            inputId="pageSize"
            isSearchable={false}
            menuPlacement="top"
            name="pagesize"
            options={pageSizeOptions}
            value={pageSizeOptions.find(option => option.value === pageSize)}
            width="80px"
            onChange={option => onPageSizeChange(option ? option.value : 10)}
          />
        </PageSizeContainer>

        <KiperButton
          disabled={loading || !hasPrevious}
          variant="text"
          color="secondary"
          name="page"
          rounded
          icon={<ChevronLeft />}
          onClick={handlePreviousPage}
        />
        <KiperButton
          disabled={loading || !hasNext}
          variant="text"
          color="secondary"
          name="page"
          onClick={handleNextPage}
          rounded
          icon={<ChevronRight />}
        />
      </FormGroup>
    </Container>
  );
};

export default SimplePagination;

SimplePagination.propTypes = {
  pageSize: propTypes.number,
  hasNext: propTypes.bool,
  hasPrevious: propTypes.bool,
  onPageChange: propTypes.func.isRequired,
  onPageSizeChange: propTypes.func.isRequired,
  loading: propTypes.bool,
  translate: propTypes.func.isRequired,
};

SimplePagination.defaultProps = {
  pageSize: 10,
  hasNext: false,
  hasPrevious: false,
  loading: false,
};
